module.exports = __webpack_public_path__ + "static/media/alis18.96494f2e.jpg";